/*
 * Warenkorb „Dazu passend“ (snippets/cm-cart-upsell.liquid, Inhaber 01.10.2026: „we need an upsell once things are in the
 * Warenkorb“). Ein Klick auf „In den Warenkorb“ legt genau diese Variante hinein (/cart/add.js) und zeichnet den Warenkorb
 * neu: im Drawer über Shopifys Section Rendering (dieselbe Methode wie das Produktformular: cart-drawer.renderContents),
 * auf der Seite /cart durch Neuladen — Zwischensumme, Rabatt „Schutzglas mit Hülle“ und die Vorschläge stimmen dann wieder.
 * Ein Fehler steht als Fehler da („Nicht in den Warenkorb gelegt: …“), nie als Erfolg. Ein Listener für alle Kästen
 * (der Drawer ersetzt sein HTML; Scripts darin liefen nicht noch einmal).
 */
(function () {
  if (window.cmCartUpsell) return;
  window.cmCartUpsell = true;
  // Texte in der Sprache der Seite: window.cmT.cart_upsell aus snippets/cm-x-js-texts (Texte in snippets/cm-xt-js, Abschnitt cart_upsell).
  // Fehlt cmT oder ein Schlüssel, gilt der deutsche Text hier; {name} wird ersetzt.
  var cmTexts = (window.cmT && window.cmT.cart_upsell) || {};
  var tx = function (key, de, vars) {
    var own = cmTexts[key];
    var text = typeof own === 'string' && own && !/^(translation missing|\[text fehlt)/i.test(own) ? own : de;
    return vars ? text.replace(/\{(\w+)\}/g, function (all, name) { return name in vars ? vars[name] : all; }) : text;
  };
  var addUrl = function () {
    return (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
  };
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cm-cu-add]') : null;
    if (!btn || btn.disabled) return;
    var box = btn.closest('[data-cm-cart-upsell]');
    var status = box ? box.querySelector('[data-cm-cu-status]') : null;
    var drawer = document.querySelector('cart-drawer');
    var inDrawer = Boolean(box && box.getAttribute('data-mode') === 'drawer' && drawer && typeof drawer.renderContents === 'function');
    var item = { id: Number(btn.getAttribute('data-cm-cu-add')), quantity: 1 };
    // Vormontage (Inhaber 10.10.2026): das Häkchen unter den Karten gehört zu genau diesem Glas (snippets/cm-premount, mode 'cart').
    var pm = box ? box.querySelector('[data-cm-premount-for="' + item.id + '"] [data-cm-premount]') : null;
    if (pm && pm.checked) item.properties = { 'Vormontage': pm.value };
    var body = { items: [item] };
    if (inDrawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = tx('adding', 'Wird hinzugefügt …');
    if (status) status.textContent = '';
    fetch(addUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok || d.status) throw new Error(d.description || d.message || 'HTTP ' + r.status);
          return d;
        });
      })
      .then(function (d) {
        if (inDrawer && d.sections && d.sections['cart-drawer']) {
          drawer.renderContents(d);
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        if (status) status.textContent = tx('not_added', 'Nicht in den Warenkorb gelegt: {reason}', { reason: err.message });
      });
  });
})();
